/**
 * Built-in named scenarios that can be loaded via URL slug.
 * Add new entries to NAMED_SCENARIOS to register additional slug → data mappings.
 *
 * Usage:
 *   sim86.se/vantande-gm  →  loads vastandeGM below
 */
import defaultScenario from "../data/scenario/default-scenario.json"
import lebelScenario from "../data/scenario/lebel.json"
import christerDelta from "../data/scenario/scenario_christer_delta.json"
import { mergeScenarios } from "./scenario-merge"

export const vastandeGM = mergeScenarios(
    defaultScenario as any,
    christerDelta as any,
    { name: "Väntande GM" }
)

/** Map from URL slug to scenario data. */
export const NAMED_SCENARIOS: Record<string, any> = {
    "vantande-gm": vastandeGM,
    "lebel": lebelScenario,
}
